import { useSession, useContent } from '../hooks/useSession';
import { checklistKey } from '../lib/curriculum';
import { Tick } from '../components/Icon';

/** Printable working checklists. The print stylesheet drops the nav and the buttons. */
export function ChecklistsPage() {
  const content = useContent();
  const { progress, toggle } = useSession();

  return (
    <div className="vu-wrap">
      <div
        style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start',
          gap: 'var(--space-6)',
        }}
      >
        <div>
          <div className="vu-kicker">Checklists</div>
          <h1 className="vu-h1">Print these and pin them up</h1>
          <p className="vu-lede" style={{ maxWidth: '58ch' }}>
            Ticks are saved to your account, so you can also run them here. The dispatch one
            is meant to live next to your packing table.
          </p>
        </div>
        <button
          type="button"
          className="vu-btn vu-noprint"
          style={{ flex: '0 0 auto' }}
          onClick={() => window.print()}
        >
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M6 9V2h12v7M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2M6 14h12v8H6z" />
          </svg>
          Print all four
        </button>
      </div>

      <div style={{ marginTop: 'var(--space-8)' }}>
        {content.checklists.map((list) => {
          const ticked = list.items.filter((_, i) => progress.ticks[checklistKey(list.id, i)]).length;
          const complete = ticked === list.items.length;
          return (
            <section
              key={list.id}
              className="vu-card"
              style={{ marginBottom: 'var(--space-5)', padding: 'var(--space-6)' }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', gap: 'var(--space-4)' }}>
                <div>
                  <h2 className="vu-h3" style={{ fontSize: 'var(--fs-h4)' }}>{list.title}</h2>
                  <p className="vu-subtle" style={{ margin: '4px 0 0' }}>{list.blurb}</p>
                </div>
                <span
                  className="vu-subtle"
                  style={{
                    whiteSpace: 'nowrap',
                    ...(complete ? { color: 'var(--green-500)', fontWeight: 600 } : {}),
                  }}
                >
                  {ticked} of {list.items.length}
                </span>
              </div>

              <div style={{ marginTop: 'var(--space-4)' }}>
                {list.items.map((item, i) => {
                  const key = checklistKey(list.id, i);
                  const on = !!progress.ticks[key];
                  return (
                    <button
                      key={key}
                      type="button"
                      className="vu-check"
                      style={{ borderTop: 0, padding: '9px 0' }}
                      onClick={() => toggle('ticks', key, !on)}
                      aria-pressed={on}
                    >
                      <span className="vu-box" data-on={on}>{on && <Tick />}</span>
                      <span
                        style={{
                          fontSize: 'var(--fs-sm)',
                          color: on ? 'var(--text-muted)' : 'var(--text-body)',
                          textDecoration: on ? 'line-through' : 'none',
                        }}
                      >
                        {item}
                      </span>
                    </button>
                  );
                })}
              </div>
            </section>
          );
        })}
      </div>
    </div>
  );
}
